import React, { memo, useMemo, ReactText } from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import { ICarrierEquipmentState, ICarrierEquipment } from 'types/carrier'
import DISPLAY from 'constants/display'
import { LabelValue } from './LabelValue'

export const FleetInformation = memo<{ data: ICarrierEquipmentState }>(
  ({ data: { equipment = [], canDropTrailer, fetching, error } }) => {
    const equipmentHash = useMemo(() => {
      let dropTrailer = DISPLAY.na
      if (typeof canDropTrailer === 'boolean') {
        dropTrailer = canDropTrailer ? 'Can Drop' : 'Cannot Drop'
      }
      return equipment.reduce(
        (hash, { count, key }: ICarrierEquipment) => ({
          ...hash,
          [key]: typeof count === 'number' ? count : DISPLAY.na,
        }),
        { dropTrailer } as { [key: string]: ReactText }
      )
    }, [equipment, canDropTrailer])

    const ready = !error && !fetching
    return (
      <div data-test='fleet-details'>
        <div className='pv2'>
          <strong>Fleet Information</strong>
        </div>
        {error && <InlineMessage message={error} type={INLINE_MESSAGE_VARIANTS.ALERT} />}
        {fetching && <Spinner />}
        {ready && (
          <>
            <LabelValue label='Power Units' fmcsa>
              {equipmentHash.power_units}
            </LabelValue>
            <LabelValue label='Total Trailers' fmcsa>
              {equipmentHash.trailers}
            </LabelValue>
            <LabelValue label='Dry Van'>{equipmentHash.dry_van}</LabelValue>
            <LabelValue label='Reefer'>{equipmentHash.reefer}</LabelValue>
            <LabelValue label='Flatbed or Stepdeck'>{equipmentHash.open_deck}</LabelValue>
            <LabelValue label='Drop Trailer'>{equipmentHash.dropTrailer}</LabelValue>
          </>
        )}
      </div>
    )
  }
)
